

export default {
  kategoriList: [],
  subKategoriList : [],
  campaign: [],
  totalRecords: 0,
  totalFiltered: 0,
  totalKatRecords: 0,
  totalSubKatRecords: 0
}
